module.exports = __webpack_public_path__ + "static/media/f3.3efbdb3a.jpg";